// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { type ReactElement, type ReactNode } from "react";

import { FormattedMessage, defineMessages } from "react-intl";

export const MonthlyPayouts = (): ReactElement => (
    <FormattedMessage
        id="apps.lensInsights.components.payoutMonetizationTab.monthlyPayouts"
        description="Monthly payouts."
        defaultMessage="Monthly Payouts"
    />
);
MonthlyPayouts.displayName = "MonthlyPayouts";

export const MonthlyPayoutsTooltip = (): ReactElement => (
    <FormattedMessage
        id="apps.lensInsights.components.payoutMonetizationTab.monthlyPayoutsTooltip"
        description="Monthly payouts tooltip."
        defaultMessage="How much you earned each month."
    />
);
MonthlyPayoutsTooltip.displayName = "MonthlyPayoutsTooltip";

export const RewardedLensesTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.lensInsights.components.payoutMonetizationTab.rewardedLensesTitle"
        description="Rewarded lenses title."
        defaultMessage="Earning Lenses"
    />
);
RewardedLensesTitle.displayName = "RewardedLensesTitle";

export const ColumnIcon = (): ReactElement => (
    <FormattedMessage
        id="apps.lensInsights.components.payoutMonetizationTab.columnIcon"
        description="Column icon."
        defaultMessage="Icon"
    />
);
ColumnIcon.displayName = "ColumnIcon";

export const ColumnName = (): ReactElement => (
    <FormattedMessage
        id="apps.lensInsights.components.payoutMonetizationTab.columnName"
        description="Column name."
        defaultMessage="Name"
    />
);
ColumnName.displayName = "ColumnName";

export const ColumnPayoutCount = (): ReactElement => (
    <FormattedMessage
        id="apps.lensInsights.components.payoutMonetizationTab.columnPayoutCount"
        description="Column payout count."
        defaultMessage="Payout Count"
    />
);
ColumnPayoutCount.displayName = "ColumnPayoutCount";

export const ColumnSubscriberActions = (): ReactElement => (
    <FormattedMessage
        id="apps.lensInsights.components.payoutMonetizationTab.columnSubscriberActions"
        description="Column subscriber actions."
        defaultMessage="Lens+ Users"
    />
);
ColumnSubscriberActions.displayName = "ColumnSubscriberActions";

export const ColumnSubscriberActionsTooltip = (): ReactElement => (
    <FormattedMessage
        id="apps.lensInsights.components.payoutMonetizationTab.columnSubscriberActionsTooltip"
        description="Column subscriber actions tooltip."
        defaultMessage="The number of Lens+ subscribers who sent, posted, or played your Lens. The more they interact with it, the more you earn."
    />
);
ColumnSubscriberActionsTooltip.displayName = "ColumnSubscriberActionsTooltip";

export const ColumnSubscriberActionsTooltipMeta = (): ReactElement => (
    <FormattedMessage
        id="apps.lensInsights.components.payoutMonetizationTab.columnSubscriberActionsTooltipMeta"
        description="Column subscriber actions tooltip meta."
        defaultMessage="Used in payout formula · Data starting from April 1, 2026"
    />
);
ColumnSubscriberActionsTooltipMeta.displayName = "ColumnSubscriberActionsTooltipMeta";

export const ColumnPayout = (): ReactElement => (
    <FormattedMessage
        id="apps.lensInsights.components.payoutMonetizationTab.columnPayout"
        description="Column payout."
        defaultMessage="Payout"
    />
);
ColumnPayout.displayName = "ColumnPayout";

export const ColumnSubscriberSignups = (): ReactElement => (
    <FormattedMessage
        id="apps.lensInsights.components.payoutMonetizationTab.columnSubscriberSignups"
        description="Column subscriber signups."
        defaultMessage="Lens+ Signups"
    />
);
ColumnSubscriberSignups.displayName = "ColumnSubscriberSignups";

export const ColumnPayoutScore = (): ReactElement => (
    <FormattedMessage
        id="apps.lensInsights.components.payoutMonetizationTab.columnPayoutScore"
        description="Column payout score."
        defaultMessage="Payout Score"
    />
);
ColumnPayoutScore.displayName = "ColumnPayoutScore";

export const ColumnActions = (): ReactElement => (
    <FormattedMessage
        id="apps.lensInsights.components.payoutMonetizationTab.columnActions"
        description="Column actions."
        defaultMessage="Actions"
    />
);
ColumnActions.displayName = "ColumnActions";

export const NoRewardedLenses = (): ReactElement => (
    <FormattedMessage
        id="apps.lensInsights.components.payoutMonetizationTab.noRewardedLenses"
        description="No rewarded lenses."
        defaultMessage="No earning Lenses for the selected time range"
    />
);
NoRewardedLenses.displayName = "NoRewardedLenses";

export const NoDataAvailable = (): ReactElement => (
    <FormattedMessage
        id="apps.lensInsights.components.payoutMonetizationTab.noDataAvailable"
        description="No data available."
        defaultMessage="No data available for the selected time range"
    />
);
NoDataAvailable.displayName = "NoDataAvailable";

export const CountryBreakdown = (): ReactElement => (
    <FormattedMessage
        id="apps.lensInsights.components.payoutMonetizationTab.countryBreakdown"
        description="Country breakdown."
        defaultMessage="Country Breakdown"
    />
);
CountryBreakdown.displayName = "CountryBreakdown";

export const SelectLensSubtitle = (): ReactElement => (
    <FormattedMessage
        id="apps.lensInsights.components.payoutMonetizationTab.selectLensSubtitle"
        description="Select lens subtitle."
        defaultMessage="Select a Lens to filter data"
    />
);
SelectLensSubtitle.displayName = "SelectLensSubtitle";

export const ShowingSelectedLens = (props: { lensName: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.lensInsights.components.payoutMonetizationTab.showingSelectedLens"
        description="Showing selected lens."
        defaultMessage="Showing data for {lensName}"
        values={props}
    />
);
ShowingSelectedLens.displayName = "ShowingSelectedLens";

export const ClearSelection = (): ReactElement => (
    <FormattedMessage
        id="apps.lensInsights.components.payoutMonetizationTab.clearSelection"
        description="Clear selection."
        defaultMessage="Clear Lens selection"
    />
);
ClearSelection.displayName = "ClearSelection";

export const TosWarningMessage = (): ReactElement => (
    <FormattedMessage
        id="apps.lensInsights.components.payoutMonetizationTab.tosWarningMessage"
        description="Tos warning message."
        defaultMessage="To view monetization data, please review and accept the terms for each payout program."
    />
);
TosWarningMessage.displayName = "TosWarningMessage";

export const ViewTerms = (): ReactElement => (
    <FormattedMessage
        id="apps.lensInsights.components.payoutMonetizationTab.viewTerms"
        description="View terms."
        defaultMessage="View Terms"
    />
);
ViewTerms.displayName = "ViewTerms";

export const ScrollForMoreMonths = (): ReactElement => (
    <FormattedMessage
        id="apps.lensInsights.components.payoutMonetizationTab.scrollForMoreMonths"
        description="Scroll for more months."
        defaultMessage="Scroll horizontally to see more months"
    />
);
ScrollForMoreMonths.displayName = "ScrollForMoreMonths";

export const messages = defineMessages({
    searchPlaceholder: {
        id: "apps.lensInsights.components.payoutMonetizationTab.searchPlaceholder",
        description: "Search placeholder.",
        defaultMessage: "Search Lenses",
    },
});
